import { render, staticRenderFns } from "./CardQrcode.vue?vue&type=template&id=2c5aefec"
import script from "./CardQrcode.vue?vue&type=script&lang=js"
export * from "./CardQrcode.vue?vue&type=script&lang=js"
import style0 from "./CardQrcode.vue?vue&type=style&index=0&id=2c5aefec&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5aefec')) {
      api.createRecord('2c5aefec', component.options)
    } else {
      api.reload('2c5aefec', component.options)
    }
    module.hot.accept("./CardQrcode.vue?vue&type=template&id=2c5aefec", function () {
      api.rerender('2c5aefec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/identifiers/components/CardQrcode.vue"
export default component.exports